// URL params owned by each Scheduled Instant sub-nav section.
//
// The sub-nav clears EVERY section-owned param on a switch (in one URL write)
// so the section left behind can't bleed into the next one. `SUBNAV_RESET` is
// DERIVED from the per-section lists, so adding a new section param in one
// place flows into the reset list automatically — no "forgot to add it to the
// reset list" leak (the trap an explicit hand-maintained drop-list would have).
//
// NOTE: Master's filter uses URL key `status` (the state var is named `filter`
// in index.tsx, but the query key is `status`).

/** Slot section: calendar/table/attention view, selected week, client filter. */
export const SLOT_PARAMS = ['view', 'week', 'client', 'adate'] as const;
/** Master Jadwal section: active/inactive/all schedule filter. */
export const MASTER_PARAMS = ['status'] as const;

/** Superset of every section-owned key — dropped on any sub-nav switch. */
export const SUBNAV_RESET = [...SLOT_PARAMS, ...MASTER_PARAMS] as const;

/**
 * Slot's `view` toggle: `adate` is owned by the attention view, so drop it when
 * leaving that view. `week`/`client` are slot-global and persist.
 */
export const VIEW_RESET = ['adate'] as const;
